$(document).ready(function($) {

    /* AJAX Basket Updater */

    var timeout;

    $('div.woocommerce').on('change keyup mouseup', 'input.qty', function(){ // keyup and mouseup for Firefox support
        if (timeout != undefined) clearTimeout(timeout); //cancel previously scheduled event
        if ($(this).val() == '') return; //qty empty, instead of removing item from cart, do nothing
        timeout = setTimeout(function() {
            $('[name="update_cart"]').trigger('click');
        }, 500 );
    });

    /* AJAX Add to Cart */

    $(function($) {

        $('form.cart').on('submit', function(e) {

            e.preventDefault();

            // Check to see if this is an external product by checking the form method
            if( $(this).attr('method') === 'get' ) {
                window.location = $(this).attr('action');
                return;
            }

            var form = $(this);
            form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

            var formData = new FormData(form[0]);
            formData.append('add-to-cart', form.find('[name=add-to-cart]').val() );

            // Ajax action.
            $.ajax({
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                complete: function( response ) {
                    response = response.responseJSON;

                    console.log(wc_add_to_cart_params);

                    if ( ! response ) {
                        return;
                    }

                    if ( response.error && response.product_url ) {
                        window.location = response.product_url;
                        return;
                    }

                    // Redirect to cart option
                    if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
                        window.location = wc_add_to_cart_params.cart_url;
                        return;
                    }

                    var thisbutton = form.find('.single_add_to_cart_button');
                    
                    // Get the current add to cart text to compensate for translations
                    var addToCart = $('.single_add_to_cart_button').html(); 

                    // Trigger event so themes can refresh other areas.
                    $(document.body).trigger('added_to_cart', [ response.fragments, response.cart_hash, thisbutton ] );

                    // Remove existing notices
                    $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

                    // Get the translations for "Added" from a data attribute we've added to the single product page
                    $('.single_add_to_cart_button').html($('.wc-product').data('added') + ' <span class="icon-tick"></span>');

					// Change button text after 4 seconds
                    setTimeout(function() {
						$('.single_add_to_cart_button').html(addToCart);
					}, 4 * 1000);

                    form.unblock();
                }
            });
        });
    });

	$(document).ready(function($){
		$('body').on( 'adding_to_cart', function(data, $thisbutton){
			$($thisbutton).parent().block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });
		});

		$('body').on( 'added_to_cart', function(event, fragments, cart_hash, button){

			$(button).html($(button).data('added') + ' <span class="icon-tick"></span>');
			$(button).parent().unblock();

			// Change button text after 4 seconds
			setTimeout(function() {
				$(button).html($(button).data('add-to-cart'));
                $(button).removeClass('added');
			}, 4 * 1000);
		});
	});

    function calculateHeadingHeight() {
        var headingHeight = $('#masthead').outerHeight();
        $('#page')[0].style.setProperty('--heading-height', headingHeight + 'px');

    }

    $(window).on('resize', function() {
        $('body').addClass('no-transition');
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
            $('body').removeClass('no-transition');
        }, 250);
        calculateHeadingHeight();
    });

    calculateHeadingHeight();

    //check when the user scrolls, if they have been scrolling up for more than 100px, show the header
    var lastScrollTop = 0;
    $(window).on('scroll', function() {
        var st = $(this).scrollTop();
        if (st >= $('#page').css('--heading-height').replace('px', '')) {
            $('#masthead').addClass('fixed').removeClass('init');
            window.setTimeout(function() {
                $('#masthead').removeClass('no-transition');
            }, 10);
            if (st > lastScrollTop) {
                // downscroll code
                $('#masthead').removeClass('init');
                $('.back-to-top').removeClass('visible');
            } else {
                // upscroll code
                $('#masthead').addClass('init');
                $('.back-to-top').addClass('visible');
            }
            //set the new last scroll top only if the user has scrolled more than 100px
            if (Math.abs(st - lastScrollTop) > 100) {
                lastScrollTop = st;
            }
        } else {
            $('#masthead').addClass('no-transition').addClass('init');
            $('.back-to-top').removeClass('visible');
        }
    });

    $('.back-to-top a').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, 800);
    });

    if ($('body').hasClass('single')) {
        var data = {
            'action': 'freightline_check_post_related_services_industries',
            'post_id': $('#post_id').val()
        };

        $.post(ajaxurl, data, function(response) {
            if (response.success == true) {
                $('#related-single-content').after(response.data).remove();
            }
        });
    }

    $('a[href^="#"]').on('click', function(e) {
        if ($($(this).attr('href')).hasClass('video-modal')) {
            jQuery.getScript( "//cdnjs.cloudflare.com/ajax/libs/hls.js/0.5.14/hls.min.js", function () {
                $('body').addClass('modal-visible');
                if (document.getElementById("cover-video")) {
                    document.getElementById("cover-video").pause();
                    document.getElementById("cover-video").currentTime = 0;
                    document.getElementById("cover-video").muted = true;
                }
                $('.cf-video iframe').attr('src', $('.cf-video iframe').attr('data-src'));
                // video = $('.cf-player')[0];
                // let video_id = $(video).data('video-id');
                // let hls = new Hls();
                // let video_hls_source = "https://videodelivery.net/" + video_id + "/manifest/video.m3u8";
                // if (Hls.isSupported()) {
                //     hls.loadSource(video_hls_source);
                //     hls.attachMedia(video);
                // } else if (video.canPlayType('application/vnd.apple.mpegURL')) {
                //     console.error('HLS stream not supported')
                //     video.src = video_hls_source;
                // }
            });
        }
        e.preventDefault();
    });

    $('.video__wrapper .close-video').on('click', function(e) {
        $('body').removeClass('modal-visible');
        $('.cf-video iframe').attr('src', '');
        document.getElementById("cover-video").play();
    });

    //add keyboard navigation to the modal
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('body').hasClass('modal-visible')) {
            $('body').removeClass('modal-visible');
            $('.cf-video iframe').attr('src', '');
            document.getElementById("cover-video").play();
        }
    });

});
